import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "store-list",
  class StoreList extends WYATTElement {
    constructor() {
      super();

      this.resultsList = this.querySelector("[data-results]");
      this.handlesToElements = new Map();
    }

    connectedCallback() {
      this.resultsList
        .querySelectorAll("[data-store-handle]")
        .forEach((element) => {
          this.handlesToElements.set(element.dataset.storeHandle, element);
        });

      this.subscribe(WYATT.PubSub.events.storesSorted, this.render.bind(this));
    }

    render() {
      this.renderList();
      this.setAttribute("store-list-ready", "");
    }

    renderList() {
      const { sortedStores } = WYATT.Geolocation;

      if (sortedStores == null) {
        return;
      }

      this.resultsList.replaceChildren();

      sortedStores.forEach((store) => {
        const { handle } = store;
        const element = this.handlesToElements.get(handle);

        if (element) {
          this.resultsList.appendChild(element);
        }
      });
    }
  },
);
